import { filterTabMap, LIST_MODEL } from '@web-mail/common/constant';
export const genSubordinateState = () => {
    return {
        listLoading: false,
        subordinateListLoading: false,
        colleagueListLoading: false,
        refreshBtnLoading: false,
        selectedFolder: { ids: [], subordinateId: '', relationEmailList: [], key: '' },
        treeList: [],
        subordinateList: [],
        subordinateTreeList: [],
        showSubordinateMock: false,
        hasCloseSubordinateMock: false,
        expandedKeys: ['all'],
        expandedSubKeys: [],
        selectedSubordinateKeys: { key: '', id: '', title: '', nickName: '', email: '' },
        refreshHasNewMail: false,
        mailDataList: [],
        mailTotal: 20,
        scrollTop: 0,
        noticeNum: 0,
        activeIds: [],
        mailListMenuVisible: false,
        mailListStateTab: 'ALL',
        selectedMailId: { id: '', accountId: '' },
        mailListInitIsFailed: false,
        mailListResizeProcessing: false,
        mailTabs: filterTabMap.subordinate,
        defaultMailListSelectedModel: LIST_MODEL.INIT,
        readMailWindowActiveMailId: null,
        shouSdTabByAuth: true,
        searchLoading: false,
        searchLoadingMore: false,
        mailSearchKey: '',
        mailSearchType: 'all',
        mailSearchState: '',
        searchingRequestId: null,
        searchList: [],
        searchTotal: 0,
        activeSearchMailId: '',
        advancedSearchVisible: false,
        advancedSearchLoading: false,
        advanceSearchFromValues: {},
        mailSearchRecord: true,
        isSearchRecorded: false,
        groupCollapseKeys: [],
        searchGroupCollapseKeys: [],
        more_searchLoading: false,
        more_searchingRequestId: null,
        more_searchInputValue: '',
        more_advancedSearchVisible: false,
        more_advancedSearchLoading: false,
        more_advanceSearchFromValues: {},
        more_searchGroupCollapseKeys: [],
        more_searchEmails: [],
    };
};
